export default __webpack_public_path__ + "static/media/iftikharrashahq.c453db46.mp4";